export default "__VITE_ASSET__ZHaGs7Tb__"